import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMoon, faSun, faToggleOff, faToggleOn,
} from '@fortawesome/free-solid-svg-icons';
import { ThemeContext } from 'utils/context';
import Button from 'components/UI/Button';

function ThemeMode({
    className,
})
{
    const {
        darkMode, setDarkMode,
    } = useContext(ThemeContext);

    function updateDarkMode()
    {
        setDarkMode(darkMode ? '' : true);
    }

    return (
        <Button
            className={`tw-flex tw-justify-center ${className}`}
            onClick={() =>
            {
                updateDarkMode();
            }}
        >
            <FontAwesomeIcon icon={faSun} className="tw-mr-2 tw-text-white dark:tw-text-black" />
            <FontAwesomeIcon icon={darkMode ? faToggleOn : faToggleOff} className="tw-mr-2 tw-cursor-pointer tw-text-white dark:tw-text-black" />
            <FontAwesomeIcon icon={faMoon} className="tw-text-white dark:tw-text-black" />
        </Button>
    );
}

ThemeMode.propTypes = {
    className: PropTypes.string,
};

export default ThemeMode;
